<template>
  <div>
    <!--{{ scope.productType-->
    <!--}}<span v-if="isNotNull(scope.productType)">类</span><span-->
    <!--v-if="-->
    <!--isNotNull(scope.productType) &&-->
    <!--isNotNull(scope.deliveryPeriod)-->
    <!--"-->
    <!--&gt;，</span>-->
    <span v-if="isNotNull(scope.deliveryPeriod)" :style="scope.deliveryPeriod>=90?{color:'red'}:''">{{ scope.deliveryPeriod }}{{ $t('addConfigModule.day') }}</span>
    <span v-if="isNotNull(scope.deliveryPeriod)&&(scope.supplyStatus != null||isNotNull(scope.ordersPreparationTime))">,</span>
    <!--<span>{{ scope.ordersPreparationTime != null ? scope.ordersPreparationTime : 0  }}天</span>-->
    <span v-if="isNotNull(scope.ordersPreparationTime)">{{ scope.ordersPreparationTime }}{{ $t('addConfigModule.day') }}</span>
    <span v-if="scope.supplyStatus != null&&isNotNull(scope.ordersPreparationTime)">,</span>
    <span v-if="scope.supplyStatus != null" style="color: red">{{ scope.supplyStatus }}</span>

    <!--<span v-if="scope.supplyStatus != null" class="promotion2"><img src="@/assets/gongyingjinque.png"/></span>-->
  </div>
</template>

<script>
import {
  isNotNull
} from '@/utils/mUtils';
export default {
  name: 'ProductTypeFormation',
  props: {
    scope: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  data () {
    return {};
  },
  methods: {
    isNotNull
  }
};
</script>

<style scoped>

  .promotion2{
    width: 40px;
    height: 20px;
    display: inline-block;
  }
  .promotion2 img{
    width: 40px;
    height: 20px;
    vertical-align: middle;
  }
  .promotion2:hover img{
    width: 45px;
    vertical-align: middle;
  }

</style>
